import React from 'react';
import { X } from 'react-feather';
import ModalShell from './ModalShell';

const Viewer = ({ logo, dimsLabel, onClose }) => (
	<ModalShell
		onClose={onClose}
		ariaLabel="Full-size logo preview"
		className="image-upload-viewer"
		scrimClassName="is-viewer"
		style={{ maxWidth: 760, background: 'transparent', boxShadow: 'none' }}
	>
		<div className="image-upload-viewer__header">
			<span>{logo.name || logo.file || 'Logo'}</span>
			<button type="button" onClick={onClose} aria-label="Close preview">
				<X size={20} />
			</button>
		</div>
		<div className="image-upload-viewer__panel">
			<img src={logo.src} alt={logo.name || logo.file || 'Logo'} />
		</div>
		<div className="image-upload-viewer__meta">
			{logo.dims && <span>{logo.dims}</span>}
			{logo.dims && logo.size ? <span> · </span> : null}
			{logo.size && <span>{logo.size}</span>}
			{(logo.dims || logo.size) && <span> · </span>}
			<span>renders at {dimsLabel || '696×200'} on banners &amp; PDFs</span>
		</div>
	</ModalShell>
);

export default Viewer;
